import { useNavigate } from 'react-router-dom';

import AddIcon from '@mui/icons-material/Add';
import {
    Box,
    Button,
    Card,
    CircularProgress,
    Grid,
    Pagination,
    Typography
} from '@mui/material';
import { useTranslation } from 'react-i18next';

import { usePlansTemplates } from '../../../hooks/usePlansTemplates';
import PlanosCard from './PlanosCard';

function DashboardPlanos() {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const {
        data: plans,
        isLoading,
        error,
        count,
        paginationModel,
        setPaginationModel
    } = usePlansTemplates();

    const handlePageChange = (_, newPage) => {
        setPaginationModel((previous) => ({
            ...previous,
            page: newPage - 1
        }));
    };

    return (
        <Box sx={{ minHeight: 'calc(100vh - 80px)', p: 2, bgcolor: '#F4F6F8' }}>
            <Box
                component="header"
                sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}
            >
                <Button
                    variant="contained"
                    startIcon={<AddIcon />}
                    onClick={() => navigate('/planos/criar')}
                    sx={{
                        width: { xs: '100%', sm: 'auto' },
                        minWidth: 195,
                        height: 46,
                        borderRadius: 1.5,
                        fontWeight: 700,
                        whiteSpace: 'nowrap',
                        textTransform: 'none'
                    }}
                >
                    {t('plans.addNew')}
                </Button>
            </Box>

            <Card
                variant="outlined"
                sx={{
                    p: 4,
                    borderColor: '#E0E5E9',
                    borderRadius: 2,
                    boxShadow: '0 1px 3px rgba(38, 50, 56, 0.08)'
                }}
            >
                <Grid container spacing={3}>
                    {isLoading ? (
                        <Grid item xs={12}>
                            <Box display="flex" justifyContent="center" p={4}>
                                <CircularProgress />
                            </Box>
                        </Grid>
                    ) : error ? (
                        <Grid item xs={12}>
                            <Typography color="error" align="center">
                                {t('plans.load_error')}
                            </Typography>
                        </Grid>
                    ) : plans.length === 0 ? (
                        <Grid item xs={12}>
                            <Typography align="center">
                                {t('plans.none_available')}
                            </Typography>
                        </Grid>
                    ) : (
                        <>
                            {plans.map((plan) => (
                                <Grid key={plan.uuid} item lg={4} md={6} sm={6} xs={12}>
                                    <PlanosCard
                                        planName={plan.name}
                                        planDesc={plan.description}
                                        pacientType={`${t('plans.created')} ${new Date(
                                            plan.created
                                        ).toLocaleDateString()}`}
                                        onClick={() => navigate(`/planos/${plan.uuid}`)}
                                    />
                                </Grid>
                            ))}

                            <Grid item xs={12}>
                                <Box display="flex" justifyContent="center" mt={4}>
                                    <Pagination
                                        count={Math.ceil(
                                            count / paginationModel.pageSize
                                        )}
                                        page={paginationModel.page + 1}
                                        onChange={handlePageChange}
                                    />
                                </Box>
                            </Grid>
                        </>
                    )}
                </Grid>
            </Card>
        </Box>
    );
}

export default DashboardPlanos;
